<template>
  <page>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12 lg12>
          <v-expansion-panels v-model="panel" multiple>
            <v-expansion-panel>
            <v-expansion-panel-header>
              <v-expansion-panel-header>
                <div>
                  <v-icon>mdi-filter-variant</v-icon> {{label.filters}}
                </div>
              </v-expansion-panel-header>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="ePanelHeaderColor">
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                      <v-flex xs12 md6 lg6>
                        <v-text-field v-model="form.survNo" :label="label.survNo" :error-messages="errors.collect('survNo')" data-vv-name="survNo" :data-vv-as="label.survNo" append-icon="mdi-magnify" @click:append="getHelpList()" v-validate="'required'" readonly></v-text-field>
                      </v-flex>
                      <v-flex xs12 md6 lg6>
                        <v-text-field v-model="form.verCnt" :label="label.verCnt" :error-messages="errors.collect('verCnt')" data-vv-name="verCnt" :data-vv-as="label.verCnt" v-validate="'required'"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-flex>

        <v-flex xs12 sm6 md6 lg6>
          <v-btn  class="mr-2" color="primary" type="submit" :loading="loading" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
              {{label.export}}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
              <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
                <span>{{format.label}}</span>
                <v-icon :color="format.color">{{format.icon}}</v-icon>
              </v-btn>
          </v-btn-toggle>
        </v-flex>
        <!-- <v-flex xs12 sm6 md6 lg6>
          <v-checkbox v-model="form.printRptRunTime" :label="label.printRptRunTime" data-vv-name="printRptRunTime" :data-vv-as="label.printRptRunTime"></v-checkbox>
        </v-flex> -->
      </v-layout>

      <v-dialog v-model="showSurveyReportHelpList" width="1280px">
        <survey-report-help-list v-if="showSurveyReportHelpList" :apiURI="this.helplistapiURI" @close="showSurveyReportHelpList = false" @assign-survey-report="assignValue"></survey-report-help-list>
      </v-dialog>

    </v-container>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { reportFormat } from '@/const/report'
import { extractMenu } from '@/utils/extract'
import SurveyReportHelpList from './SurveyReportHelpList'

export default {
  data() {
    return {
      label: {
        filters: 'Filters',
        survNo: 'Survey No.',
        verCnt: 'Version Count',
        export: 'Export To',
        printRptRunTime: 'Print report runtime parameters'
      },
      form: {
        survNo: '',
        verCnt: 0,
        format: 'PDF',
        printRptRunTime: false
      },
      loading: false,
      menu: {},
      supportedFormat: [],
      showSurveyReportHelpList: false,
      helplistapiURI: '',
      panel: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.uwReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  methods: {
    async doInit() {
      try {
        if (this.$store.state.reports.uwReports.menu !== 1) {
          await Promise.all([this.$store.dispatch('uwReportsInit')])
        }
        const apiURI = this.rptMenu.initRiskSurvey
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
          this.helplistapiURI = this.menu.getSurvMasterHelpList
        }
      } catch (err) {
        throw err
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.genRiskSurveyRpt
      if (apiURI) {
        try {
          this.loading = true
          await this.$http.post(apiURI, this.form)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    getHelpList() {
      this.showSurveyReportHelpList = true
    },
    assignValue(data) {
      this.form.survNo = data.survNo
      this.form.verCnt = data.verCnt
      this.showSurveyReportHelpList = false
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    MessageMixin
  ],
  components: {
    SurveyReportHelpList
  }
}
</script>

<style>

</style>
